const HORA = /^(\d{1,2}):(\d{2})(?::00)?$/;

const MINUTOS_NO_DIA = 24 * 60;

function paraHHMM(minutos: number): string {
  return `${String(Math.floor(minutos / 60)).padStart(2, "0")}:${String(minutos % 60).padStart(2, "0")}`;
}

// Converte o valor de uma célula de hora da planilha para HH:MM, o que o backend recebe.
// Aceita H:MM, HH:MM e HH:MM:00 em texto, e a fração do dia que o Excel guarda numa célula
// formatada como hora. Vazio devolve ""; valor que não é hora válida devolve null.
export function normalizarHora(valor: unknown): string | null {
  if (valor === null || valor === undefined) return "";
  if (typeof valor === "number") {
    // Um dia ou mais é data, ou hora digitada sem os dois-pontos (800): não é hora.
    const minutos = Math.round(valor * MINUTOS_NO_DIA);
    return valor >= 0 && minutos < MINUTOS_NO_DIA ? paraHHMM(minutos) : null;
  }
  const texto = String(valor).trim();
  if (texto === "") return "";
  const m = HORA.exec(texto);
  if (!m) return null;
  const hora = Number(m[1]);
  const minuto = Number(m[2]);
  return hora < 24 && minuto < 60 ? paraHHMM(hora * 60 + minuto) : null;
}
